module.exports = __webpack_public_path__ + "media/images/help/faq-sticker-status-sp-03953f9cd59a9dff32fa28d4828694c5.jpg";